(function () {
  const YEARS = ['2025','2022','2019'];
  const EDITIONS = ['standard','datacenter'];

  function buildIndexMap() {
    const map = new Map();
    const headerRow = document.querySelector('#features-table .sticky-row-2');
    if (!headerRow) return map;

    const ths = Array.from(headerRow.children);
    ths.forEach((th, i) => {
      const classes = [...th.classList];
      const yeClass = classes.find(c => /^\d{4}-(standard|datacenter)$/.test(c));
      if (yeClass) {
        map.set(yeClass, i + 1);
        return;
      }
      const txt = th.textContent.trim().toLowerCase();
      const candidates = [
        ['2025-standard', '2025 standard'],
        ['2025-datacenter', '2025 datacenter'],
        ['2022-standard', '2022 standard'],
        ['2022-datacenter', '2022 datacenter'],
        ['2019-standard', '2019 standard'],
        ['2019-datacenter', '2019 datacenter'],
      ];
      for (const [key, needle] of candidates) {
        if (txt.includes(needle)) {
          map.set(key, i + 1);
          break;
        }
      }
    });
    return map;
  }

  function setColumnVisibleByIndex(colIndex, show) {
    if (!colIndex || colIndex < 1) return;
    document.querySelectorAll('#features-table tr').forEach(tr => {
      const cell = tr.children[colIndex - 1];
      if (cell) cell.style.display = show ? '' : 'none';
    });
  }

  function anyEditionChecked(year) {
    return EDITIONS.some(e => {
      const cb = document.getElementById(`${year}-${e}`);
      return cb && cb.checked;
    });
  }

  function syncMaster(year) {
    const master = document.getElementById(year);
    if (master) master.checked = anyEditionChecked(year);
  }

  function applyEdition(keyMap, year, edition) {
    const key = `${year}-${edition}`;
    const idx = keyMap.get(key);
    const cb = document.getElementById(key);
    const show = !!(cb && cb.checked);
    setColumnVisibleByIndex(idx, show);
  }

  function renderAll(keyMap) {
    YEARS.forEach(year => {
      EDITIONS.forEach(ed => applyEdition(keyMap, year, ed));
      syncMaster(year);
    });
    const anyOn = YEARS.some(anyEditionChecked);
    const table = document.getElementById('table-container');
    const error = document.getElementById('table-container-error');
    if (table && error) {
      table.style.display = anyOn ? '' : 'none';
      error.style.display = anyOn ? 'none' : '';
    }
  }

  function bindHandlers(keyMap) {
    YEARS.forEach(year => {
      EDITIONS.forEach(ed => {
        const cb = document.getElementById(`${year}-${ed}`);
        if (cb) {
          cb.onchange = function () {
            applyEdition(keyMap, year, ed);
            syncMaster(year);
            const anyOn = YEARS.some(anyEditionChecked);
            const table = document.getElementById('table-container');
            const error = document.getElementById('table-container-error');
            if (table && error) {
              table.style.display = anyOn ? '' : 'none';
              error.style.display = anyOn ? 'none' : '';
            }
          };
        }
      });
      const master = document.getElementById(year);
      if (master) {
        master.onchange = function () {
          const state = master.checked;
          EDITIONS.forEach(ed => {
            const cb = document.getElementById(`${year}-${ed}`);
            if (cb) cb.checked = state;
          });
          renderAll(keyMap);
        };
      }
    });

    const allBtn = document.getElementById('select-all');
    if (allBtn) allBtn.onclick = function () {
      YEARS.forEach(y => {
        const master = document.getElementById(y);
        if (master) master.checked = true;
        EDITIONS.forEach(ed => {
          const cb = document.getElementById(`${y}-${ed}`);
          if (cb) cb.checked = true;
        });
      });
      renderAll(keyMap);
    };

    const noneBtn = document.getElementById('select-none');
    if (noneBtn) noneBtn.onclick = function () {
      YEARS.forEach(y => {
        const master = document.getElementById(y);
        if (master) master.checked = false;
        EDITIONS.forEach(ed => {
          const cb = document.getElementById(`${y}-${ed}`);
          if (cb) cb.checked = false;
        });
      });
      renderAll(keyMap);
    };
  }

  window.toggleGroup = function (year) {
    const state = !!document.getElementById(year)?.checked;
    EDITIONS.forEach(ed => {
      const cb = document.getElementById(`${year}-${ed}`);
      if (cb) cb.checked = state;
    });
    const map = buildIndexMap();
    renderAll(map);
  };

  function init() {
    const toggles = document.querySelector('.matrix-toggles');
    if (toggles) toggles.style.display = 'block';

    const map = buildIndexMap();
    bindHandlers(map);
    renderAll(map);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();


// $(function () {
//     $("#2022-standard").click(function () {
//       if ($(".2022-standard").is(":visible")){
//         if ($(".2022-datacenter").is(":visible")){
//           if($("#2022").prop("disabled")){
//             $("#2022-datacenter").prop("checked") && $("#2022-datacenter").prop("disabled", true);
//           }
//           $(".column-2022.column-header").attr('colspan', 1);
//           $(".2022-standard").hide();
//         } else {
//           $("#2022").prop("checked", false);
//           $(".column-2022.column-header").attr('colspan', 1);
//           $(".column-2022").hide();
//           toggleTableView();
//         }
//       } else {
//         if ($(".2022-datacenter").is(":visible")){
//           if($("#2022").prop("disabled")){
//             $("#2022-datacenter").prop("checked") && $("#2022-datacenter").prop("disabled", false);
//           }
//           $(".column-2022.column-header").attr('colspan', 2);
//           $(".2022-standard").show();
//         } else {
//           $("#2022").prop("checked", true);
//           $(".column-2022.column-header").show();
//           $(".column-2022.column-header").attr('colspan', 1);
//           $(".2022-standard").show();
//           toggleTableView();
//         }
//       }
//     });
//     $("#2022-datacenter").click(function () {
//       if ($(".2022-datacenter").is(":visible")){
//         if ($(".2022-standard").is(":visible")){
//           if($("#2022").prop("disabled")){
//             $("#2022-standard").prop("checked") && $("#2022-standard").prop("disabled", true);
//           }
//           $(".column-2022.column-header").attr('colspan', 1);
//           $(".2022-datacenter").hide();
//         } else {
//           $("#2022").prop("checked", false);
//           $(".column-2022.column-header").attr('colspan', 1);
//           $(".column-2022").hide();
//           toggleTableView();
//         }
//       } else {
//         if ($(".2022-standard").is(":visible")){
//           if($("#2022").prop("disabled")){
//             $("#2022-standard").prop("checked") && $("#2022-standard").prop("disabled", false);
//           }
//           $(".column-2022.column-header").attr('colspan', 2);
//           $(".2022-datacenter").show();
//         } else {
//           $("#2022").prop("checked", true);
//           $(".column-2022.column-header").show();
//           $(".column-2022.column-header").attr('colspan', 1);
//           $(".2022-datacenter").show();
//           toggleTableView();
//         }
//       }
//     });
//     $("#2019-standard").click(function () {
//       if ($(".2019-standard").is(":visible")){
//         if ($(".2019-datacenter").is(":visible")){
//           if ($(".2019-essentials").is(":visible")){
//             $(".column-2019.column-header").attr('colspan', 2);
//             $(".2019-standard").hide();
//           } else {
//             if($("#2019").prop("disabled")){
//               $("#2019-datacenter").prop("disabled", true);
//             }
//             $(".column-2019.column-header").attr('colspan', 1);
//             $(".2019-standard").hide();
//           }
//         } else {
//           if ($(".2019-essentials").is(":visible")){
//             if($("#2019").prop("disabled")){
//               $("#2019-essentials").prop("disabled", true);
//             }
//             $(".column-2019.column-header").attr('colspan', 1);
//             $(".2019-standard").hide();
//           } else {
//             $("#2019").prop("checked", false);
//             $(".column-2019.column-header").attr('colspan', 1);
//             $(".column-2019").hide();
//             toggleTableView();
//           }
//         }
//       } else {
//         if ($(".2019-datacenter").is(":visible")){
//           if ($(".2019-essentials").is(":visible")){
//             $(".column-2019.column-header").attr('colspan', 3);
//             $(".2019-standard").show();
//           } else {
//             $(".column-2019.column-header").attr('colspan', 2);
//             $(".2019-standard").show();
//           }
//         } else {
//           if ($(".2019-essentials").is(":visible")){
//             $(".column-2019.column-header").attr('colspan', 2);
//             $(".2019-standard").show();
//           } else {
//             $("#2019").prop("checked", true);
//             $(".column-2019.column-header").show();
//             $(".column-2019.column-header").attr('colspan', 1);
//             $(".2019-standard").show();
//             toggleTableView();
//           }
//         }
//       }
//     });
//     $("#2019-datacenter").click(function () {
//       if ($(".2019-datacenter").is(":visible")){
//         if ($(".2019-standard").is(":visible")){
//           if ($(".2019-essentials").is(":visible")){
//             $(".column-2019.column-header").attr('colspan', 2);
//             $(".2019-datacenter").hide();
//           } else {
//             if($("#2019").prop("disabled")){
//               $("#2019-standard").prop("disabled", true);
//             }
//             $(".column-2019.column-header").attr('colspan', 1);
//             $(".2019-datacenter").hide();
//           }
//         } else {
//           if ($(".2019-essentials").is(":visible")){
//             if($("#2019").prop("disabled")){
//               $("#2019-essentials").prop("disabled", true);
//             }
//             $(".column-2019.column-header").attr('colspan', 1);
//             $(".2019-datacenter").hide();
//           } else {
//             $("#2019").prop("checked", false);
//             $(".column-2019.column-header").attr('colspan', 1);
//             $(".column-2019").hide();
//             toggleTableView();
//           }
//         }
//       } else {
//         if ($(".2019-standard").is(":visible")){
//           if ($(".2019-essentials").is(":visible")){
//             $(".column-2019.column-header").attr('colspan', 3);
//             $(".2019-datacenter").show();
//           } else {
//             $(".column-2019.column-header").attr('colspan', 2);
//             $(".2019-datacenter").show();
//           }
//         } else {
//           if ($(".2019-essentials").is(":visible")){
//             $(".column-2019.column-header").attr('colspan', 2);
//             $(".2019-datacenter").show();
//           } else {
//             $("#2019").prop("checked", true);
//             $(".column-2019.column-header").show();
//             $(".column-2019.column-header").attr('colspan', 1);
//             $(".2019-datacenter").show();
//             toggleTableView();
//           }
//         }
//       }
//     });
//     $("#2019-essentials").click(function () {
//       if ($(".2019-essentials").is(":visible")){
//         if ($(".2019-datacenter").is(":visible")){
//           if ($(".2019-standard").is(":visible")){
//             $(".column-2019.column-header").attr('colspan', 2);
//             $(".2019-essentials").hide();
//           } else {
//             if($("#2019").prop("disabled")){
//               $("#2019-datacenter").prop("disabled", true);
//             }
//             $(".column-2019.column-header").attr('colspan', 1);
//             $(".2019-essentials").hide();
//           }
//         } else {
//           if ($(".2019-standard").is(":visible")){
//             if($("#2019").prop("disabled")){
//               $("#2019-standard").prop("disabled", true);
//             }
//             $(".column-2019.column-header").attr('colspan', 1);
//             $(".2019-essentials").hide();
//           } else {
//             $("#2019").prop("checked", false);
//             $(".column-2019.column-header").attr('colspan', 1);
//             $(".column-2019").hide();
//             toggleTableView();
//           }
//         }
//       } else {
//         if ($(".2019-datacenter").is(":visible")){
//           if ($(".2019-standard").is(":visible")){
//             $(".column-2019.column-header").attr('colspan', 3);
//             $(".2019-essentials").show();
//           } else {
//             $(".column-2019.column-header").attr('colspan', 2);
//             $(".2019-essentials").show();
//           }
//         } else {
//           if ($(".2019-standard").is(":visible")){
//             $(".column-2019.column-header").attr('colspan', 2);
//             $(".2019-essentials").show();
//           } else {
//             $("#2019").prop("checked", true);
//             $(".column-2019.column-header").show();
//             $(".column-2019.column-header").attr('colspan', 1);
//             $(".2019-essentials").show();
//             toggleTableView();
//           }
//         }
//       }
//     });
//     $("#2016-standard").click(function () {
//         if ($(".2016-standard").is(":visible")){
//           if ($(".2016-datacenter").is(":visible")){
//             if ($(".2016-essentials").is(":visible")){
//               $(".column-2016.column-header").attr('colspan', 2);
//               $(".2016-standard").hide();
//             } else {
//               if($("#2016").prop("disabled")){
//                 $("#2016-datacenter").prop("disabled", true);
//               }
//               $(".column-2016.column-header").attr('colspan', 1);
//               $(".2016-standard").hide();
//             }
//           } else {
//             if ($(".2016-essentials").is(":visible")){
//               if($("#2016").prop("disabled")){
//                 $("#2016-essentials").prop("disabled", true);
//               }
//               $(".column-2016.column-header").attr('colspan', 1);
//               $(".2016-standard").hide();
//             } else {
//               $("#2016").prop("checked", false);
//               $(".column-2016.column-header").attr('colspan', 1);
//               $(".column-2016").hide();
//               toggleTableView();
//             }
//           }
//         } else {
//           if ($(".2016-datacenter").is(":visible")){
//             if ($(".2016-essentials").is(":visible")){
//               $(".column-2016.column-header").attr('colspan', 3);
//               $(".2016-standard").show();
//             } else {
//               $(".column-2016.column-header").attr('colspan', 2);
//               $(".2016-standard").show();
//             }
//           } else {
//             if ($(".2016-essentials").is(":visible")){
//               $(".column-2016.column-header").attr('colspan', 2);
//               $(".2016-standard").show();
//             } else {
//               $("#2016").prop("checked", true);
//               $(".column-2016.column-header").show();
//               $(".column-2016.column-header").attr('colspan', 1);
//               $(".2016-standard").show();
//               toggleTableView();
//             }
//           }
//         }
//       });
//       $("#2016-datacenter").click(function () {
//         if ($(".2016-datacenter").is(":visible")){
//           if ($(".2016-standard").is(":visible")){
//             if ($(".2016-essentials").is(":visible")){
//               $(".column-2016.column-header").attr('colspan', 2);
//               $(".2016-datacenter").hide();
//             } else {
//               if($("#2016").prop("disabled")){
//                 $("#2016-standard").prop("disabled", true);
//               }
//               $(".column-2016.column-header").attr('colspan', 1);
//               $(".2016-datacenter").hide();
//             }
//           } else {
//             if ($(".2016-essentials").is(":visible")){
//               if($("#2016").prop("disabled")){
//                 $("#2016-essentials").prop("disabled", true);
//               }
//               $(".column-2016.column-header").attr('colspan', 1);
//               $(".2016-datacenter").hide();
//             } else {
//               $("#2016").prop("checked", false);
//               $(".column-2016.column-header").attr('colspan', 1);
//               $(".column-2016").hide();
//               toggleTableView();
//             }
//           }
//         } else {
//           if ($(".2016-standard").is(":visible")){
//             if ($(".2016-essentials").is(":visible")){
//               $(".column-2016.column-header").attr('colspan', 3);
//               $(".2016-datacenter").show();
//             } else {
//               $(".column-2016.column-header").attr('colspan', 2);
//               $(".2016-datacenter").show();
//             }
//           } else {
//             if ($(".2016-essentials").is(":visible")){
//               $(".column-2016.column-header").attr('colspan', 2);
//               $(".2016-datacenter").show();
//             } else {
//               $("#2016").prop("checked", true);
//               $(".column-2016.column-header").show();
//               $(".column-2016.column-header").attr('colspan', 1);
//               $(".2016-datacenter").show();
//               toggleTableView();
//             }
//           }
//         }
//       });
//       $("#2016-essentials").click(function () {
//         if ($(".2016-essentials").is(":visible")){
//           if ($(".2016-datacenter").is(":visible")){
//             if ($(".2016-standard").is(":visible")){
//               $(".column-2016.column-header").attr('colspan', 2);
//               $(".2016-essentials").hide();
//             } else {
//               if($("#2016").prop("disabled")){
//                 $("#2016-datacenter").prop("disabled", true);
//               }
//               $(".column-2016.column-header").attr('colspan', 1);
//               $(".2016-essentials").hide();
//             }
//           } else {
//             if ($(".2016-standard").is(":visible")){
//               if($("#2016").prop("disabled")){
//                 $("#2016-standard").prop("disabled", true);
//               }
//               $(".column-2016.column-header").attr('colspan', 1);
//               $(".2016-essentials").hide();
//             } else {
//               $("#2016").prop("checked", false);
//               $(".column-2016.column-header").attr('colspan', 1);
//               $(".column-2016").hide();
//               toggleTableView();
//             }
//           }
//         } else {
//           if ($(".2016-datacenter").is(":visible")){
//             if ($(".2016-standard").is(":visible")){
//               $(".column-2016.column-header").attr('colspan', 3);
//               $(".2016-essentials").show();
//             } else {
//               $(".column-2016.column-header").attr('colspan', 2);
//               $(".2016-essentials").show();
//             }
//           } else {
//             if ($(".2016-standard").is(":visible")){
//               $(".column-2016.column-header").attr('colspan', 2);
//               $(".2016-essentials").show();
//             } else {
//               $("#2016").prop("checked", true);
//               $(".column-2016.column-header").show();
//               $(".column-2016.column-header").attr('colspan', 1);
//               $(".2016-essentials").show();
//               toggleTableView();
//             }
//           }
//         }
//       });
//     $("#select-all").click(function () {
//       $("#2022").prop("checked", true);
//       $("#2019").prop("checked", true);
//       $("#2016").prop("checked", true);

//       $("#2022-standard").prop("checked", true);
//       $("#2022-datacenter").prop("checked", true);
//       $("#2019-standard").prop("checked", true);
//       $("#2019-datacenter").prop("checked", true);
//       $("#2019-essentials").prop("checked", true);
//       $("#2016-standard").prop("checked", true);
//       $("#2016-datacenter").prop("checked", true);
//       $("#2016-essentials").prop("checked", true);

//       $(".column-2022.column-header").attr('colspan', 2);
//       $(".column-2022").show();
//       $(".column-2019.column-header").attr('colspan', 3);
//       $(".column-2019").show();
//       $(".column-2016.column-header").attr('colspan', 3);
//       $(".column-2016").show();

//       toggleTableView();
//     });
//     $("#select-none").click(function () {
//       $("#2022").prop("checked", false);
//       $("#2019").prop("checked", false);
//       $("#2016").prop("checked", false);

//       $("#2022-standard").prop("checked", false);
//       $("#2022-datacenter").prop("checked", false);
//       $("#2019-standard").prop("checked", false);
//       $("#2019-datacenter").prop("checked", false);
//       $("#2019-essentials").prop("checked", false);
//       $("#2016-standard").prop("checked", false);
//       $("#2016-datacenter").prop("checked", false);
//       $("#2016-essentials").prop("checked", false);

//       $(".column-2022").hide();
//       $(".column-2019").hide();
//       $(".column-2016").hide();



//       toggleTableView();
//     });
//     $(".matrix-toggles").show();
// });

//   function uncheckToggle(toggle){
//     if ($(toggle).prop("checked") == true) {
//       $(toggle).click();
//     }
//   }
//   function checkToggle(toggle){
//     if ($(toggle).prop("checked") == false) {
//       $(toggle).click();
//     }
//   }

//   function toggleGroup(group){
//     if (group == '2022') {
//       if ($("#2022").prop("checked") == false) {
//         uncheckToggle("#2022-standard");
//         uncheckToggle("#2022-datacenter");
//       } else {
//         checkToggle("#2022-standard");
//         checkToggle("#2022-datacenter");
//       }
//     } else if (group == '2019') {
//       if ($("#2019").prop("checked") == false) {
//         uncheckToggle("#2019-standard");
//         uncheckToggle("#2019-datacenter");
//         uncheckToggle("#2019-essentials");
//       } else {
//         checkToggle("#2019-standard");
//         checkToggle("#2019-datacenter");
//         checkToggle("#2019-essentials");
//       }
//     } else if (group == '2016') {
//       if ($("#2016").prop("checked") == false) {
//         uncheckToggle("#2016-standard");
//         uncheckToggle("#2016-datacenter");
//         uncheckToggle("#2016-essentials");
//       } else {
//         checkToggle("#2016-standard");
//         checkToggle("#2016-datacenter");
//         checkToggle("#2016-essentials");
//       }
//     }
//   }

//   function toggleTableView(){
//     if (($("#2022").prop("checked") == false) && ($("#2019").prop("checked") == false) && ($("#2016").prop("checked") == false)){
//         $('#table-container').hide();
//         $('#table-container-error').show();
//     } else {
//         $('#table-container-error').hide();
//         $('#table-container').show();
//     }
//   }



